//  _        _      _         _
// | |  _  _| |_  _| |__ _  _| |__ _  _
// | |_| || | | || | '_ \ || | '_ \ || |
// |____\_,_|_|\_,_|_.__/\_,_|_.__/\_,_|
//
// Copyright © Lulububu Software GmbH - All Rights Reserved
// https://lulububu.de
//
// Unauthorized copying of this file, via any medium is strictly prohibited!
// Proprietary and confidential.

import { makeActionCreator } from '@/helper/Store';

export const ConfigurationTypes = {
    FETCH_CONFIGURATION:           'Configuration/FETCH_CONFIGURATION',
    FETCH_CONFIGURATION_SUCCEEDED: 'Configuration/FETCH_CONFIGURATION_SUCCEEDED',
    FETCH_CONFIGURATION_FAILED:    'Configuration/FETCH_CONFIGURATION_FAILED',
};

const fetchConfiguration = makeActionCreator(
    ConfigurationTypes.FETCH_CONFIGURATION,
    {},
);

const fetchConfigurationSucceeded = makeActionCreator(
    ConfigurationTypes.FETCH_CONFIGURATION_SUCCEEDED,
    {},
);

const fetchConfigurationFailed = makeActionCreator(
    ConfigurationTypes.FETCH_CONFIGURATION_FAILED,
    {},
);

export const ConfigurationActions = {
    fetchConfiguration,
    fetchConfigurationSucceeded,
    fetchConfigurationFailed,
};
